module.exports = __webpack_public_path__ + "static/bg_hotel-509b83f7aee4df9610fc07e1877427ba.jpg";